web = {
	storage_name: "spaceistanbul",
	map_loaded: 0,
	labels: {},
	media_server: "https://crm.spaceistanbul.com",
};

web.initialize_app = function () {
	$("#content-container").fadeTo(300, 1);
	web.get("/functions/_lib/labels.php", function (result, labels) {
		web.labels = JSON.parse(labels);
		web.labels = web.labels[web.current_language_code];
	});
	$(window).on("user.signed_in", function () {
		location.reload();
	});
	$(window).on("user.signed_out", function () {
		location.reload();
	});
	$(".auction-documents .document").on("click", function (e) {
		e.preventDefault();
		const url = this.href;
		const filename = this.getAttribute('data-filename');
		web.start_download(url, decodeURIComponent(filename));
	});

	window.aiChatManager = new AIChatManager();
	$("#ai-chat-button").on("click", function () {
		aiChatManager.openSidenav();
	});
};

//visitor
web.create_visitor_id = function () {
	user_agent = navigator.userAgent;
	time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	time = Date.now();
	visitor_id = time_zone + "|" + time + "|" + user_agent;
	visitor_id = visitor_id.substr(0, 400);
	return visitor_id;
}

web.initialize_visitor = function () {
	try {
		web.visitor = window.localStorage.getItem(web.storage_name);
		if (web.visitor) {
			web.visitor = JSON.parse(web.visitor);
		} else {
			visitor_id = web.create_visitor_id();

			web.visitor = {
				id: visitor_id,
				visited_list: [],
				favorite_list: [],
				compare_list: []
			};
		}

		if (!web.visitor.visited_list) {
			web.visitor.visited_list = [];
		}

		if (!web.visitor.favorite_list) {
			web.visitor.favorite_list = [];
		}
		if (!web.visitor.compare_list) {
			web.visitor.compare_list = [];
		}
		return web.save_visitor();
	} catch (err) {
		console.log(err);
		return -1;
	}
};

web.save_visitor = function () {
	try {
		window.localStorage.setItem(web.storage_name, JSON.stringify(web.visitor));
		return 1;
	} catch (err) {
		console.log(err);
		return -1;
	}
};

//user lists
web.is_in_list = function (id, list) {
	try {
		if (list.indexOf(id) >= 0) {
			return 1;
		} else {
			return 0;
		}
	}
	catch (err) {
		console.log(err);
		return -1;
	}
};

web.add_to_list = function (id, list) {
	try {
		for (i = list.length - 1; i >= 0; i--) {
			if (list[i] == id) {
				list.splice(i, 1);
				break;
			}
		}
		list.unshift(id);
		if (list.length > 1000) {
			list.splice(999);
		}
		return web.save_visitor();
	}
	catch (err) {
		console.log(err);
		return -1;
	}
};

web.remove_from_list = function (id, list) {
	try {
		for (i = list.length - 1; i >= 0; i--) {
			if (list[i] == id) {
				list.splice(i, 1);
				break;
			}
		}
		return web.save_visitor();
	} catch (err) {
		console.log(err);
		return -1;
	}
};

//visited list
web.get_visited_list = function () {
	if (web.visitor && web.visitor.visited_list) {
		return web.visitor.visited_list;
	}
	else {
		return [];
	}
};

web.is_in_visited_list = function (product_id) {
	visitor_list = web.get_visited_list();
	return is_in_list(product_id, visitor_list);
};

web.add_to_visited_list = function (product_id) {
	visitor_list = web.get_visited_list();
	return web.add_to_list(product_id, visitor_list)
}

web.remove_from_visited_list = function (product_id) {
	visitor_list = web.get_visited_list();
	return web.remove_from_list(product_id, visitor_list)
};

//ui
web.initialize_ui = function () {
	$(".product").each(function () {
		$node = $(this);
		id = $node.attr("data-id");
		if (web.is_in_favorites(id)) {
			$node.find(".add-to-favorites").css("display", "none");
			$node.find(".remove-from-favorites").css("display", "inline-block");
		} else {
			$node.find(".add-to-favorites").css("display", "inline-block");
			$node.find(".remove-from-favorites").css("display", "none");
		}

		if (web.is_in_compare_list(id)) {
			$node.find(".add-to-compare-list").css("display", "none");
			$node.find(".remove-from-compare-list").css("display", "inline-block");
		} else {
			$node.find(".add-to-compare-list").css("display", "inline-block");
			$node.find(".remove-from-compare-list").css("display", "none");
		}

		$node
			.find(".add-to-favorites")
			.off("click")
			.on("click", function (e) {
				e.stopPropagation();
				e.preventDefault();
				$node = $(this).closest(".product");
				id = $node.attr("data-id");
				web.remove_from_favorites(id);
				web.user.favorites.unshift(id);
				web.save_user();
				if (typeof get_favorite_products == "function") {
					get_favorite_products();
				}
				$node.find(".add-to-favorites").css("display", "none");
				$node.find(".remove-from-favorites").css("display", "inline-block");
			});

		$node
			.find(".remove-from-favorites")
			.off("click")
			.on("click", function (e) {
				e.stopPropagation();
				e.preventDefault();
				$node = $(this).closest(".product");
				id = $node.attr("data-id");
				web.remove_from_favorites(id);
				web.save_user();
				if (typeof get_favorite_products == "function") {
					get_favorite_products();
				}
				$node.find(".remove-from-favorites").css("display", "none");
				$node.find(".add-to-favorites").css("display", "inline-block");
			});

		$node
			.find(".add-to-compare-list")
			.off("click")
			.on("click", function (e) {
				e.stopPropagation();
				e.preventDefault();
				$node = $(this).closest(".product");
				id = $node.attr("data-id");
				web.remove_from_compare_list(id);
				web.user.compare_list.unshift(id);
				web.save_user();
				if (typeof get_compared_products == "function") {
					get_compared_products();
				}
				$node.find(".add-to-compare-list").css("display", "none");
				$node.find(".remove-from-compare-list").css("display", "inline-block");
				web.post("common", { action: "add_to_compare_list", id: id });
			});

		$node
			.find(".remove-from-compare-list")
			.off("click")
			.on("click", function (e) {
				e.stopPropagation();
				e.preventDefault();
				$node = $(this).closest(".product");
				id = $node.attr("data-id");
				web.remove_from_compare_list(id);
				web.save_user();
				if (typeof get_compared_products == "function") {
					get_compared_products();
				}
				$node.find(".remove-from-compare-list").css("display", "none");
				$node.find(".add-to-compare-list").css("display", "inline-block");
			});
		$node.find(".action").removeClass("transparent");
	});
};

//stories
web.get_story_product_stats = function (data, call_back) {
	web.post("stories", { action: "get_product_stats", data: data }, function (result, data) {
		if (result == 1) {
			call_back(data)
		}
		else {
			call_back(null);
		}
	});
}

web.insert_product_like = function (data, call_back) {
	web.is_member(function (is_member) {
		if (is_member == 0) {
			web.display_not_member_modal();
		}
		else {
			web.post("stories", { action: "insert_like", data: data }, function (result, data) {
				if (result == 1) {
					call_back(data)
				}
				else {
					call_back(null);
				}
			});
		}
	});
}

web.delete_product_like = function (data, call_back) {
	web.post("stories", { action: "delete_like", data: data }, function (result, data) {
		if (result == 1) {
			call_back(data)
		}
		else {
			call_back(null);
		}
	});
}

web.display_product_likes = function (data, call_back) {
	web.get("/modals/story_likes.php", function (result, html) {
		if (result == 1) {
			$("#story-likes-modal").remove();
			$html = $(html).appendTo("#modal-container");
			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			web.post("stories", { action: "get_product", data: data }, function (result, data) {
				if (result == 1) {
					if (data.product) {
						product = data.product;
						$("#story-likes-modal #likes").html(product.likes_html);
					}
				}
				else {
					call_back(null);
				}
			});

			web.modal.show();
		}
	});
}

web.insert_product_share = function (data) {
	web.post("stories", { action: "insert_share", data: data }, function (result, data) {
		if (result == 1) {
			console.log("share inserted");
		}
	});
}

web.insert_product_message = function (data) {
	data.settings = [];
	data.settings.push({ key: "message", value: data.message });
	web.post("stories", { action: "insert_message", data: data }, function (result, data) {
		if (result == 1) {

		}
	});
}

//visited products
web.get_visited_products_slider = function (call_back) {
	product_ids = web.get_visited_list();
	web.post("products", {
		action: "get_visited_products_slider",
		product_ids: product_ids
	}, function (result, data) {
		call_back(data.html);
	});
}

web.get_visited_products = function (call_back) {
	product_ids = web.get_visited_list();
	web.post("products", {
		action: "get_visited_products",
		product_ids: product_ids
	}, function (result, data) {
		call_back(data.html);
	});
}

web.insert_product_visit = function (options) {
	web.post("products", {
		action: "insert_product_visit",
		product_id: options.product_id,
		visitor_id: web.visitor.id
	}, function (result, data) { });
}

web.insert_product_call = function (options) {
	web.post("products", {
		action: "insert_product_call",
		product_id: options.product_id,
		visitor_id: web.visitor.id
	}, function (result, data) { });
}

web.insert_whatsapp_chat = function (options) {
	web.post("products", {
		action: "insert_product_chat",
		product_id: options.product_id,
		visitor_id: web.visitor.id
	}, function (result, data) { });
}

//search
web.encode_search_command = function (cmd) {
	return $.base64.encode(JSON.stringify(cmd));
};

//site
web.insert_site_visit = function (options) {
	web.post("sites", {
		action: "insert_site_visit",
		site_id: options.site_id,
		visitor_id: web.visitor.id
	}, function (result, data) { });
}

//modals
web.applicant_clarification_text_modal = function (options) {
	web.get("/modals/applicant_clarification_text.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html
				.find("#close-button")
				.off("click")
				.on("click", function () {
					clarification_modal.hide();
				});

			$html.on("hidden.bs.modal", function () {
				if (clarification_modal) {
					clarification_modal.dispose();
				}
				$("#applicant-clarification-text-modal").remove();
			});
			clarification_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			clarification_modal.show();
		}
	});
};

web.auction_info_request_modal = function (options, call_back) {
	web.get("/modals/auction_info_request.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");
			$html.find("input, select, textarea").on("change keyup", function () {
				can_be_submitted = true;
				$form = $html.find("form");
				$form.find("input[required]").each(function () {
					type = $(this).attr("type");
					if (type == "text") {
						if ($(this).val().length == 0) {
							can_be_submitted = false;
						}
					}
				});
				if ($form.find("#i-read").length > 0) {
					if ($form.find("#i-read").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if ($form.find("#i-agree").length > 0) {
					if ($form.find("#i-agree").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if (can_be_submitted == true) {
					$html.find("#ok").removeAttr("disabled");
				} else {
					$html.find("#ok").attr("disabled", true);
				}
			});

			$html.find("#ok").on("click", async function () {
				if ($form.find("#content").val().length > 0) {
					const token = await grecaptcha.enterprise.execute(web.captcha_key, {
						action: 'LOGIN'
					});
					if (token) {
						form_data = {};
						form_data.token = token;
						form_data.form_category_id = options.form_category_id;
						form_data.auction_id = options.auction_id;
						form_data.auction_user_id = options.auction_user_id;
						form_data.first_name = $form.find("#first-name").val();
						form_data.last_name = $form.find("#last-name").val();
						form_data.email = $form.find("#email").val();
						form_data.phone = itl.getNumber();
						form_data.content = $form.find("#content").val();

						web.post("common", { action: "send_form", data: form_data }, function (result, data) {
							if (result == 1 && data.id > 0) {
								if (call_back) {
									call_back(form_data);
								}
								web.thanks_modal();
							}
						});
					}
					if (web.modal) {
						web.modal.hide();
					}
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#auction-info-request-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.auction_visit_modal = function (options, call_back) {
	web.get("/modals/auction_visit.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");
			initialize_auction_visit_modal(options);

			$html.find("input, select, textarea").on("change keyup", function () {
				can_be_submitted = true;
				$form = $html.find("form");
				$form.find("input[required]").each(function () {
					type = $(this).attr("type");
					if (type == "text") {
						if ($(this).val().length == 0) {
							can_be_submitted = false;
						}
					}
				});
				if ($form.find("#i-agree").length > 0) {
					if ($form.find("#i-agree").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if (can_be_submitted == true) {
					$html.find("#ok").removeAttr("disabled");
				} else {
					$html.find("#ok").attr("disabled", true);
				}
			});

			$html.find("#ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					data = {};
					data.token = token;
					data.form_category_id = options.form_category_id;
					data.auction_id = options.auction_id;
					data.product_id = options.product_id;
					data.auction_user_id = options.auction_user_id;
					data.first_name = $form.find("#first-name").val();
					data.last_name = $form.find("#last-name").val();
					data.email = $form.find("#email").val();
					data.phone = itl.getNumber();
					data.product_visit_day = $form.find("#auction-visit-day").val();
					data.product_visit_hour = $form.find("#auction-visit-hour").val();

					web.post("common", { action: "send_form", data: data }, function (result, data) {
						if (result == 1 && data.id > 0) {
							web.thanks_modal();
							if (call_back) {
								call_back();
							}
						}
					});
				}

				if (web.modal) {
					web.modal.hide();
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#auction-visit-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.cookie_policy_modal = function (options) {
	web.get("/modals/cookie_policy.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html
				.find("#close-button")
				.off("click")
				.on("click", function () {
					cookie_policy_modal.hide();
				});

			$html.on("hidden.bs.modal", function () {
				if (cookie_policy_modal) {
					cookie_policy_modal.dispose();
				}
				$("#cookie-policy-modal").remove();
			});
			cookie_policy_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			cookie_policy_modal.show();
		}
	});
};

web.clarification_text_modal = function (options) {
	web.get("/modals/general_clarification_text.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html
				.find("#close-button")
				.off("click")
				.on("click", function () {
					clarification_modal.hide();
				});

			$html.on("hidden.bs.modal", function () {
				if (clarification_modal) {
					clarification_modal.dispose();
				}
				$("#general-clarification-text-modal").remove();
			});
			clarification_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			clarification_modal.show();
		}
	});
};

web.commercial_messaging_clarification_text_modal = function (options) {
	web.get("/modals/commercial_messaging_clarification_text_modal.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html
				.find("#close-button")
				.off("click")
				.on("click", function () {
					commercial_messaging_clarification_modal.hide();
				});

			$html.on("hidden.bs.modal", function () {
				$(".modal-backdrop").remove();
				if (commercial_messaging_clarification_modal) {
					commercial_messaging_clarification_modal.dispose();
				}
				$("#commercial-messaging-clarification-text-modal").remove();
			});
			commercial_messaging_clarification_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			commercial_messaging_clarification_modal.show();
		}
	});
};

web.company_policy_modal = function (options) {
	web.get("/modals/company_policy.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html
				.find("#close-button")
				.off("click")
				.on("click", function () {
					company_policy_modal.hide();
				});

			$html.on("hidden.bs.modal", function () {
				if (company_policy_modal) {
					company_policy_modal.dispose();
				}
				$("#company-policy-modal").remove();
			});
			company_policy_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			company_policy_modal.show();
		}
	});
};

web.cookie_preferences_modal = function () {
	web.get("/modals/cookie_preferences.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html.on("hidden.bs.modal", function () {
				if (cookie_preferences_modal) {
					cookie_preferences_modal.dispose();
				}
				$("#cookie-preferences-modal").remove();
			});
			cookie_preferences_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			cookie_preferences_modal.show();
		}
	});
};

web.consultant_modal = function (options) {
	web.get("/modals/consultant.php", function (result, html) {
		if (result == 1) {
			$("#consultant-modal").remove();
			$html = $(html).appendTo("#modal-container");
			$html.find("img").attr("src", options.src);
			$html.find(".name").text(options.name);
			$html.find(".title").text(options.title);
			$html.find(".profile").text(options.profile);
			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#consultant-modal").remove();
			});
			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.contact_information_clarification_text_modal = function (options) {
	web.get("/modals/contact_information_clarification_text.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html
				.find("#close-button")
				.off("click")
				.on("click", function () {
					contact_information_clarification_modal.hide();
				});

			$html.on("hidden.bs.modal", function () {
				$(".modal-backdrop").remove();
				if (contact_information_clarification_modal) {
					contact_information_clarification_modal.dispose();
				}
				$("#contact-information-clarification-text-modal").remove();
			});
			contact_information_clarification_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			contact_information_clarification_modal.show();
		}
	});
};

web.contact_us_modal = function (options, call_back) {
	web.get("/modals/contact_us.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html.find("input, select, textarea").on("change keyup", function () {
				can_be_submitted = true;
				$form = $html.find("form");
				$form.find("input[required]").each(function () {
					type = $(this).attr("type");
					if (type == "text") {
						if ($(this).val().length == 0) {
							can_be_submitted = false;
						}
					}
				});
				if ($form.find("#i-agree").length > 0) {
					if ($form.find("#i-agree").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if (can_be_submitted == true) {
					$html.find("#ok").removeAttr("disabled");
				} else {
					$html.find("#ok").attr("disabled", true);
				}
			});

			$html.find("#ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					data = {};
					data.token = token;
					data.form_category_id = options.form_category_id;
					data.auction_id = options.auction_id;
					data.product_id = 0;
					data.auction_user_id = options.auction_user_id;
					data.first_name = $form.find("#first-name").val();
					data.last_name = $form.find("#last-name").val();
					data.email = $form.find("#email").val();
					data.phone = itl.getNumber();
					data.content = $form.find("#message").val();

					web.post("common", { action: "send_form", data: data }, function (result, data) {
						if (result == 1 && data.id > 0) {
							web.thanks_modal();
							if (call_back) {
								call_back();
							}
						}
					});

					if (web.modal) {
						web.modal.hide();
					}
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#contact-us-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.display_confirm_modal = function (call_back) {
	web.get("/modals/confirm.php", function (result, html) {
		if (result == 1) {
			$("#confirm-modal").remove();
			$html = $(html).appendTo("#modal-container");

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#confirm-modal").remove();
			});

			$("#confirm-modal #ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					if (call_back) {
						web.modal.hide();
						call_back();
					}
				}
			});

			web.modal.show();
		}
	});
};

web.display_confirm_offer_modal = function (options, call_back) {
	web.get("/modals/confirm_offer.php", function (result, html) {
		if (result == 1) {
			$("#confirm-offer-modal").remove();
			$html = $(html).appendTo("#modal-container");
			$html.find("#offer-price").autoNumeric("init", { aSep: ".", aDec: ",", aPad: false }).autoNumeric("set", options.offer);
			web.post("auctions", { action: "get_last_offer", auction_id: options.auction_id }, function (result, data) {
				if (result == 1) {
					if (data.price) {
						$html.find("#actual-price").text(data.formatted_number);
					}
				}
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#confirm-offer-modal").remove();
			});

			$("#confirm-offer-modal #ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					$("#confirm-offer-modal").modal("hide");
					if (call_back) {
						call_back();
					}
				}
			});

			web.modal.show();
		}
	});
};

web.display_map_modal = function (options, call_back) {
	if (options.lat == 0 || options.lng == 0) {
		web.display_message("warning", web.labels.undefined_coordinates);
		return;
	}

	web.get("/modals/map.php", function (result, html) {
		if (result == 1) {
			$("#map-modal").remove();
			$html = $(html).appendTo("#modal-container");

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#map-modal").remove();
				web.map = null;
				web.start_autocomplete = null;
				web.directions_service = null;
				web.directions_renderer = null;
				$(".pac-container").remove();
			});

			initialize_map_modal(options);

			web.modal.show();
		}
	});
};

web.e_offer_policy_modal = function (options) {
	web.get("/modals/e_offer_policy.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html
				.find("#close-button")
				.off("click")
				.on("click", function () {
					e_offer_policy_modal.hide();
				});

			$html.on("hidden.bs.modal", function () {
				if (e_offer_policy_modal) {
					e_offer_policy_modal.dispose();
				}
				$("#e_offer-policy-modal").remove();
			});
			e_offer_policy_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			e_offer_policy_modal.show();
		}
	});
};

web.image_slider_modal = function (options) {
	web.get("/modals/image_slider.php", function (result, html) {
		if (result == 1) {
			$("#image-slider-modal").remove();
			$html = $(html).appendTo("#modal-container");
			initialize_slider_modal(options);
			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: false,
				backdrop: "static"
			});
			web.modal.show();
		}
	});
};

web.image_viewer_modal = function (options) {
	web.get("/modals/image_viewer.php", function (result, html) {
		if (result == 1) {
			$("#image-viewer-modal").remove();
			$html = $(html).appendTo("#modal-container");
			initialize_viewer_modal(options);
			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.info_request_modal = function (options, call_back) {
	web.get("/modals/info_request.php?product_id=" + options.product_id, function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			initialize_info_request_modal(options, call_back);

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#info-request-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.join_team_modal = function (options, call_back) {
	web.get("/modals/join_team.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#join-team-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.member_verification_modal = function (options, call_back) {
	$("#member-verification-modal").remove();
	web.get("/modals/member_verification.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");
			initialize_verification_modal(options, call_back)

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#member-verification-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: false,
				backdrop: options.disable_close_button == 1 ? "static" : ""
			});

			web.modal.show();
		}
	});
};

web.membership_clarification_text_modal = function (options) {
	web.get("/modals/membership_clarification_text.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html
				.find("#close-button")
				.off("click")
				.on("click", function () {
					membership_clarification_modal.hide();
				});

			$html.on("hidden.bs.modal", function () {
				if (membership_clarification_modal) {
					membership_clarification_modal.dispose();
				}
				$("#membership-clarification-text-modal").remove();
			});
			membership_clarification_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			membership_clarification_modal.show();
		}
	});
};

web.press_item_modal = function (options) {
	web.get("/modals/press_item.php", function (result, html) {
		if (result == 1) {
			$("#press-item-modal").remove();
			$html = $(html).appendTo("#modal-container");
			initialize_press_item_modal(options);
			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.product_share_modal = function (options) {
	web.get("/modals/product_share.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			options.links = {
				facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(options.url)}`,
				twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(options.url)}&text=${encodeURIComponent(options.title)}`,
				whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(options.title + ' ' + options.url)}`,
				linkedin: `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(options.url)}&title=${encodeURIComponent(options.title)}&summary=${encodeURIComponent(options.description)}`,
				email: `mailto:?subject=${encodeURIComponent(options.title)}&body=${encodeURIComponent(options.description + '\n\n' + options.url)}`
			}
			options.copy_text = `${options.title}\r\n${options.description}\r\n${options.url}`;

			initialize_modal(options);

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#product-share-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
}

web.product_visit_modal = function (options, call_back) {
	web.get("/modals/product_visit.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			initialize_product_visit_modal(options, call_back);

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#product-visit-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			web.modal.show();
		}
	});
};

web.purchase_now_modal = function (options, call_back) {
	web.get("/modals/purchase_now.php", function (result, html) {
		if (result == 1) {
			$("#purchase-now-modal").remove();
			$html = $(html).appendTo("#modal-container");

			$html.find("#ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					$form = $html.find("form");
					web.modal.hide();

					web.post("common", { action: "send_verification_sms" }, function (result, data) {
						if (result == 1 && data.success == 1 && data.sms_id && data.sms_no) {
							web.sms_verification_modal({
								sms_id: data.sms_id,
								sms_no: data.sms_no
							}, function () {
								web.post(
									"auction_members",
									{
										action: "purchase_now",
										auction_id: options.auction_id,
									},
									function (result, data) {
										if (result == 1) {
											if (data.success == 1) {
												web.success_message();
											} else if (data.success == -2) {
												web.warning_message(web.labels.err_invalid_offer);
											} else if (data.success == -3) {
												web.warning_message(web.labels.err_auction_on_hold);
											} else if (data.success == -4) {
												web.warning_message(web.labels.err_auction_on_hold);
											} else {
												web.error_message();
											}
											web.reload_page();
										}
										else {
											web.error_message();
										}
									}
								);
							});
						} else {
							web.error_message();
						}
					});
				}

			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#purchase-now-modal").remove();
			});

			$html.on("shown.bs.modal", function () {
				if (call_back) {
					call_back();
				}
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			web.modal.show();
		}
	});
};

web.rate_us_modal = function (options, call_back) {
	web.get("/modals/rate_us.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");
			$html.find("input, select, textarea").on("change keyup", function () {
				can_be_submitted = true;
				$form = $html.find("form");
				$form.find("input[required]").each(function () {
					type = $(this).attr("type");
					if (type == "text") {
						if ($(this).val().length == 0) {
							can_be_submitted = false;
						}
					}
				});
				if ($form.find("#i-read").length > 0) {
					if ($form.find("#i-read").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if ($form.find("#i-agree").length > 0) {
					if ($form.find("#i-agree").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if (can_be_submitted == true) {
					$html.find("#ok").removeAttr("disabled");
				} else {
					$html.find("#ok").attr("disabled", true);
				}
			});

			$html.find("#ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					data = {};
					data.token = token;
					data.form_category_id = options.form_category_id;
					data.product_id = options.product_id;
					data.user_id = options.user_id;
					data.first_name = $form.find("#first-name").val();
					data.last_name = $form.find("#last-name").val();
					data.email = $form.find("#email").val();
					data.phone = itl.getNumber();
					data.content = $form.find("#content").val();

					web.post("common", { action: "send_form", data: data }, function (result, data) {
						if (result == 1 && data.id > 0) {
							web.display_message("success", web.labels.operation_completed);
							if (call_back) {
								call_back();
							}
						}
					});
				}
				if (web.modal) {
					web.modal.hide();
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#rate-us-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.sale_modal = function (options, call_back) {
	web.get("/modals/sale.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html.find("input, select, textarea").on("change keyup", function () {
				can_be_submitted = true;
				$form = $html.find("form");
				$form.find("input[required]").each(function () {
					type = $(this).attr("type");
					if (type == "text") {
						if ($(this).val().length == 0) {
							can_be_submitted = false;
						}
					}
				});
				if ($form.find("#i-agree").length > 0) {
					if ($form.find("#i-agree").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if ($form.find("#captcha").val() == "0") {
					can_be_submitted = false;
				}
				if (can_be_submitted == true) {
					$html.find("#ok").removeAttr("disabled");
				} else {
					$html.find("#ok").attr("disabled", true);
				}
			});

			$html.find("#ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					data = {};
					data.token = token;
					data.form_category_id = options.form_category_id;
					data.auction_id = 0;
					data.product_id = 0;
					data.auction_user_id = options.authorized_user_id;
					data.first_name = $("#sale-modal #first-name").val();
					data.last_name = $("#sale-modal #last-name").val();
					data.email = $("#sale-modal #email").val();
					data.phone = itl.getNumber();
					data.content = $("#sale-modal #message").val();

					web.post("common", {
						action: "send_form",
						data: data
					}, function (result, data) {
						web.thanks_modal();
						if (call_back) {
							call_back();
						}
					});
				}
				if (web.modal) {
					web.modal.hide();
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#sale-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.search_request_modal = function (options, call_back) {
	web.get("/modals/search_request.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");
			$html.find("input, select, textarea").on("change keyup", function () {
				can_be_submitted = true;
				$form = $html.find("form");
				$form.find("input[required]").each(function () {
					type = $(this).attr("type");
					if (type == "text") {
						if ($(this).val().length == 0) {
							can_be_submitted = false;
						}
					}
				});
				if ($form.find("#i-read").length > 0) {
					if ($form.find("#i-read").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if ($form.find("#i-agree").length > 0) {
					if ($form.find("#i-agree").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if (can_be_submitted == true) {
					$html.find("#ok").removeAttr("disabled");
				} else {
					$html.find("#ok").attr("disabled", true);
				}
			});

			$html.find("#ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					data = {};
					data.token = token;
					data.form_category_id = options.form_category_id;
					data.product_id = 0;
					data.user_id = 0;
					data.first_name = $form.find("#first-name").val();
					data.last_name = $form.find("#last-name").val();
					data.email = $form.find("#email").val();
					data.phone = itl.getNumber();
					data.content = $form.find("#content").val();

					web.post("common", { action: "send_form", data: data }, function (result, data) {
						if (result == 1 && data.id > 0) {
							web.thanks_modal();
							if (call_back) {
								call_back();
							}
						}
					});
				}

				if (web.modal) {
					web.modal.hide();
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#search-request-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.sell_rent_modal = function (options, call_back) {
	web.get("/modals/sell_rent.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");
			data = { type: options.type };

			$html.on("hidden.bs.modal", function () {
				clearInterval(validityInterval);

				if (web.modal) {
					web.modal.dispose();
				}
				$("#sell-rent-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			web.modal.show();

		}
	});
};

web.sms_verification_modal = function (options, call_back) {
	web.get("/modals/sms_verification.php", function (result, html) {
		if (result == 1) {
			$("#sms-verification-modal").remove();
			$html = $(html).appendTo("#modal-container");

			options.try_count = 1;
			$html.find("#try-count").text(options.try_count);
			$html.find("#sms-no").text(options.sms_no);
			$input = $html.find("#sms-code");
			$input.on("focus", function () {
				$input.removeClass("bg-red text-white");
			});

			$("#sms-verification-modal #ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					$modal = $(this).closest(".modal-dialog");
					$input = $modal.find("#sms-code");
					code = $input.val().trim();
					web.post("common", {
						action: "verify_sms",
						sms_id: options.sms_id,
						sms_no: options.sms_no,
						code: code
					}, function (result, data) {
						if (result == 1) {
							if (data.is_verified == 1) {
								web.verification_modal.hide();
								call_back();
							}
						}
						else {
							options.try_count++;
							if (options.try_count <= 3) {
								$html.find("#sms-verification-modal #try-count").text(options.try_count);
								$input.addClass("bg-red text-white");
							}
							else {
								web.modal.hide();
							}
						}
					});
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.verification_modal) {
					web.verification_modal.dispose();
				}
				$("#sms-verification-modal").remove();
			});

			web.verification_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			web.verification_modal.show();
		}
	});
};

web.subscribe_modal = function (options, call_back) {
	web.get("/modals/subscribe.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#subscribe-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			web.modal.show();
		}
	});
};

web.support_modal = function (options, call_back) {
	web.get("/modals/support.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$form = $html.find("form");
			if (options.message) {
				$form.find("#message").val(options.message);
			}
			$html.find("input, select, textarea").on("change keyup", function () {
				can_be_submitted = true;
				$form.find("input[required]").each(function () {
					type = $(this).attr("type");
					if (type == "text") {
						if ($(this).val().length == 0) {
							can_be_submitted = false;
						}
					}
				});
				if ($form.find("#i-read").length > 0) {
					if ($form.find("#i-read").prop("checked") == false) {
						can_be_submitted = false;
					}
				}
				if ($form.find("#i-agree").length > 0) {
					if ($form.find("#i-agree").prop("checked") == false) {
						can_be_submitted = false;
					}
				}

				if (can_be_submitted == true) {
					$html.find("#ok").removeAttr("disabled");
				} else {
					$html.find("#ok").attr("disabled", true);
				}
			});

			$html.find("#ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					data = {};
					data.token = token;
					data.form_category_id = options.form_category_id;
					data.auction_id = options.auction_id;
					data.auction_user_id = options.auction_user_id;
					data.first_name = $form.find("#first-name").val();
					data.last_name = $form.find("#last-name").val();
					data.email = $form.find("#email").val();
					data.phone = itl.getNumber();
					data.content = $form.find("#message").val();

					web.post("common", { action: "send_form", data: data }, function (result, data) {
						if (result == 1 && data.id > 0) {
							web.thanks_modal();
							if (call_back) {
								call_back();
							}
						}
					});
				}
				if (web.modal) {
					web.modal.hide();
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#support-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.thanks_modal = function (options) {
	web.get("/modals/thanks.php", function (result, html) {
		if (result == 1) {
			$("#thanks-modal").remove();
			$html = $(html).appendTo("#modal-container");

			$html.find("#ok").on("click", function () {
				if (web.thanks_modal_dialog) {
					web.thanks_modal_dialog.hide();
				}
			});

			web.thanks_modal_dialog = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.thanks_modal_dialog.show();
		}
	});
};

web.visit_clarification_text_modal = function (options) {
	web.get("/modals/visit_clarification.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html.on("hidden.bs.modal", function () {
				if (visit_clarification_modal) {
					visit_clarification_modal.dispose();
				}
				$("#visit-clarification-text-modal").remove();
			});
			visit_clarification_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			visit_clarification_modal.show();
		}
	});
};

web.watch_list_modal = function (options, call_back) {
	web.get("/modals/watch_list.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");
			initialize_watch_list_modal(options);

			$form = $html.find("form");

			$html.find("#ok").on("click", async function () {
				const token = await grecaptcha.enterprise.execute(web.captcha_key, {
					action: 'LOGIN'
				});
				if (token) {
					web.modal.hide();
					if (options.call_back) {
						data = {};
						data.token = token;
						data.auction_id = $("#watch-list-modal #auction-id").val();
						data.product_id = $("#watch-list-modal #product-id").val();
						data.is_reminder = $("#watch-list-modal #is-reminder").prop("checked");
						data.reminder_date = $("#watch-list-modal #reminder-date").val();
						options.call_back(data);
					}
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#watch-list-modal").remove();
			});

			$html.on("shown.bs.modal", function () {
				if (call_back) {
					call_back();
				}
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			web.modal.show();
		}
	});
};

//map
web.get_direction_icon = function (maneuver) {
	switch (maneuver) {
		case "ferry":
			return "directions_boat";
		case "ferry-train":
			return "boat_railway";
		case "fork-left":
			return "fork_left";
		case "fork-right":
			return "fork_right";
		case "merge":
			return "merge";
		case "ramp-left":
			return "ramp_left";
		case "ramp-right":
			return "ramp_right";
		case "roundabout-left":
			return "roundabout_left";
		case "roundabout-right":
			return "roundabout_right";
		case "straight":
			return "straight";
		case "turn-left":
			return "turn_left";
		case "turn-right":
			return "turn_right";
		case "turn-sharp-left":
			return "turn_sharp_left";
		case "turn-sharp-right":
			return "turn_sharp_right";
		case "turn-slight-left":
			return "turn_slight_left";
		case "turn-slight-right":
			return "turn_slight_right";
		case "uturn-right":
			return "u_turn_right";
		case "uturn-left":
			return "u_turn_left";
		default:
			console.log(maneuver);
	}
	return "";
};

web.get_direction_step = function (step) {
	try {
		step.icon = web.get_direction_icon(step.maneuver);
		return `
		<div class="step" data-step-index="${step.index}">
			<span class="step-icon material-symbols-outlined">${step.icon}</span>
			<div class="step-description">
				${step.instructions}
				<div class="step-notes">
					${step.duration.text}, ${step.distance.text}
				</div>
			</div>
		</div>
		`
	} catch (error) {
		console.log(error);
	}
}

web.create_directions_button = function (label, extra_classes) {
	try {
		let el = $("<button>", {
			text: label,
			class: "btn btn-white clear",
		});
		if (extra_classes) {
			el.addClass(extra_classes)
		}
		return el.get(0);
	} catch (error) {
		console.log(error);
	}
}

web.create_navigation_link = function (label, lat, lng, extra_classes) {
	try {
		let el = $("<a>", {
			class: "btn btn-white clear",
			text: label
		});
		el.attr("href", `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`);
		el.attr("target", "_blank");
		if (extra_classes) {
			el.addClass(extra_classes)
		}
		return el.get(0);
	} catch (error) {
		console.log(error);
	}
}

web.add_map_polygon = function (map, data) {
	try {
		p = { zIndex: 1, strokeColor: "#808080", strokeOpacity: 0.5, strokeWeight: 1, fillColor: "#f97613", fillOpacity: 0 };
		options = { map: map, zIndex: p.zIndex, strokeColor: p.strokeColor, strokeOpacity: p.strokeOpacity, strokeWeight: p.strokeWeight, fillColor: p.fillColor, fillOpacity: p.fillOpacity };
		if (typeof google !== "undefined" && typeof google.maps !== "undefined") {
			paths = $.parseJSON(data.paths);
			options.paths = [];
			paths.forEach((path) => {
				path.forEach((point) => {
					path = new google.maps.LatLng(point[0], point[1]);
					options.paths.push(path);
				});
			});

			polygon = new google.maps.Polygon(options);
			polygon.data = data;
			return polygon;
		}
		return null;
	} catch (error) {
		console.log(error);
	}
}

web.fit_map_to_boundary = function (map, sw, ne) {
	try {
		if (typeof sw == "string") {
			sw = $.parseJSON(sw);
		}
		if (typeof ne == "string") {
			ne = $.parseJSON(ne);
		}
		if (map && typeof google !== "undefined" && typeof google.maps !== "undefined") {
			bounds = new google.maps.LatLngBounds(new google.maps.LatLng(sw[0], sw[1]), new google.maps.LatLng(ne[0], ne[1]));
			map.fitBounds(bounds)
		}
		return true;
	} catch (error) {
		console.log(error);
		return false;
	}
}

//member
web.display_not_member_modal = function () {
	web.get("/modals/not_member.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$("#not-member-modal #sign-in-button").on("click", function () {
				web.display_sign_in();
			});

			$("#not-member-modal #sign-up-button").on("click", function () {
				web.display_sign_up();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			$html.on("hidden.bs.modal", function () {
				$("#not-member-modal").remove();
			});

			web.modal.show();
		}
	});
};

web.display_sign_up = async function () {
	if (web.modal) {
		await web.modal.hide();
	}
	$("#sign-up-modal").remove();
	web.get("/modals/sign_up.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			if ($html) {
				web.modal = new bootstrap.Modal($html.get(0), {
					keyboard: true, focus: true,
				});

				$html.on("hidden.bs.modal", function () {
					if (web.modal) {
						web.modal.dispose();
					}
					$("#sign-up-modal").remove();
				});

				web.modal.show();
			}
		}
	});
};

web.display_sign_up_corp = async function () {
	if (web.modal) {
		await web.modal.hide();
	}
	$("#sign-up-corp-modal").remove();
	web.get("/modals/sign_up_corp.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			if ($html) {
				web.modal = new bootstrap.Modal($html.get(0), {
					keyboard: true, focus: true,
				});

				$html.on("hidden.bs.modal", function () {
					if (web.modal) {
						web.modal.dispose();
					}
					$("#sign-up-corp-modal").remove();
				});

				web.modal.show();
			}
		}
	});
};

web.display_sign_in = async function () {
	if (web.modal) {
		await web.modal.hide();
	}
	web.get("/modals/sign_in.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			if ($html) {
				web.modal = new bootstrap.Modal($html.get(0), {
					keyboard: true, focus: true,
				});

				$html.on("hidden.bs.modal", function () {
					if (web.modal) {
						web.modal.dispose();
					}
					$("#sign-in-modal").remove();
				});

				web.modal.show();
			}
		}
	});
};

web.sign_in = function (data, call_back) {
	try {
		web.post("auth", {
			action: "sign_in",
			data: data
		}, function (result, data) {
			if (result == 1) {
				if (data.success == 1) {
					web.success_message();
					if (call_back) {
						call_back(data);
					}
					$(window).trigger("user.signed_in");
				}
				else {
					web.display_message("error", web.labels.email_or_password_not_correct);
				}
			} else {
				web.display_message("error", web.labels.email_or_password_not_correct);
			}
		});
	} catch (err) {
		console.log(err);
	}
}

web.sign_out = function (call_back) {
	web.display_confirm_modal(function () {
		web.post("auth", { action: "sign_out" }, function (result, data) {
			if (result == 1) {
				if (data.success == 1) {
					if (call_back) {
						call_back(data);
					}
					$(window).trigger("user.signed_out");
				}
			}
		});
	});
};

web.is_member = function (call_back) {
	web.get_member(function (member) {
		if (member && member.id > 0) {
			call_back(1);
		}
		else {
			call_back(0);
		}
	})
};

web.get_member = function (call_back) {
	web.post(
		"common",
		{
			action: "get_member",
		},
		function (result, data) {
			if (result == 1) {
				call_back(data.member)
			}
			else {
				call_back(null);
			}
		}
	);
};

//locations
web.get_cities = function (country_id, call_back) {
	web.post(
		"common",
		{
			action: "get_cities",
			country_id: country_id
		},
		function (result, data) {
			if (result == 1) {
				call_back(data.cities)
			}
			else {
				call_back([]);
			}
		}
	);
};

web.get_towns = function (city_id, call_back) {
	web.post(
		"common",
		{
			action: "get_towns",
			city_id: city_id
		},
		function (result, data) {
			if (result == 1) {
				call_back(data.towns)
			}
			else {
				call_back([]);
			}
		}
	);
};

web.get_quarters = function (town_id, call_back) {
	web.post(
		"common",
		{
			action: "get_quarters",
			town_id: town_id
		},
		function (result, data) {
			if (result == 1) {
				call_back(data.quarters)
			}
			else {
				call_back([]);
			}
		}
	);
};

//toast
web.display_message = function (type, message) {
	if (type == "error") {
		node = $("#toast-container .toast.error");
	}
	if (type == "normal") {
		node = $("#toast-container .toast.normal");
	}
	if (type == "success") {
		node = $("#toast-container .toast.success");
	}
	if (type == "warning") {
		node = $("#toast-container .toast.warning");
	}
	node.find(".toast-message").text(message);
	web.toast = new bootstrap.Toast(node.get(0));
	web.toast.show();
};

web.normal_message = function (message) {
	if (message) {
		web.display_message("normal", message);
	}
	else {
		web.display_message("normal");
	}
};

web.success_message = function (message) {
	if (message) {
		web.display_message("success", message);
	}
	else {
		web.display_message("success", web.labels.operation_completed);
	}
};

web.error_message = function (message) {
	if (message) {
		web.display_message("error", message);
	}
	else {
		web.display_message("error", web.labels.operation_not_completed);
	}
};

web.warning_message = function (message) {
	web.display_message("warning", message);
};

// Test n8n connection (for debugging)
web.test_n8n_connection = function () {
	web.post("n8n", {
		action: "test_connection"
	}, function (result, data) {
		if (result == 1) {
			console.log("n8n Connection Test Result:", data);
			web.show_toast('success', 'n8n bağlantısı başarılı!');
		} else {
			console.error("n8n Connection Test Failed");
			web.show_toast('error', 'n8n bağlantı testi başarısız.');
		}
	});
};

// AI Chat Utilities
web.chat = {
	// Check if chat sidenav is currently open
	isOpen: function () {
		return $('#ai-chat-sidenav').hasClass('open');
	},

	// Close the chat sidenav
	close: function () {
		if (typeof aiChatManager !== 'undefined') {
			aiChatManager.closeSidenav();
		}
	},

	// Send a message programmatically
	sendMessage: function (message) {
		if (typeof aiChatManager !== 'undefined' && message && message.trim()) {
			aiChatManager.sendMessage(message.trim());
		}
	},

	// Clear chat history
	clearHistory: function () {
		if (typeof aiChatManager !== 'undefined') {
			aiChatManager.clearMessages();
		}
	},

	// Show/hide loading state
	setLoading: function (isLoading) {
		if (typeof aiChatManager !== 'undefined') {
			if (isLoading) {
				aiChatManager.showLoading();
			} else {
				aiChatManager.hideLoading();
			}
		}
	},

	// Quick access to common actions
	searchProducts: function (query) {
		if (query && query.trim()) {
			web.open_ai_chat();
			// Wait a bit for the sidenav to open, then send message
			setTimeout(function () {
				web.chat.sendMessage(query);
			}, 500);
		}
	}
};

//arrays
web.get_array_item = function (arr, fld, val) {
	target = null;
	arr.forEach((item) => {
		if (item[fld] == val) {
			target = item;
		}
	});
	return target;
}

web.get_array_items = function (arr, fld, val) {
	items = [];
	arr.forEach((item) => {
		if (item[fld] == val) {
			items.push(item);
		}
	});
	return items;
}

//objects
web.copy_object = function (obj) {
	return JSON.parse(JSON.stringify(obj));
}

//toast
web.display_message = function (type, message) {
	if (type == "error") {
		node = $("#toast-container .toast.error");
	}
	if (type == "normal") {
		node = $("#toast-container .toast.normal");
	}
	if (type == "success") {
		node = $("#toast-container .toast.success");
	}
	if (type == "warning") {
		node = $("#toast-container .toast.warning");
	}
	node.find(".toast-message").text(message);
	web.toast = new bootstrap.Toast(node.get(0));
	web.toast.show();
};


//utils
web.is_email = function (email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
};

web.get_relative_top = function (element, container) {
	let currentTop = 0;
	let currentElement = element;
	let containerTop = container.getBoundingClientRect().top;
	while (currentElement && currentElement !== container) {
		currentTop += currentElement.offsetTop - currentElement.scrollTop;
		currentElement = currentElement.offsetParent;
	}

	return currentTop - containerTop;
}

web.scroll_to_element = function (element, container) {
	scroll_top = web.get_relative_top(element, container);
	$(container).animate({
		scrollTop: scroll_top
	}, "slow");
}

web.reload_page = function (reload_time) {
	if (reload_time == undefined) {
		reload_time = web.reload_time;
	}
	setTimeout(function () {
		location.reload();
	}, reload_time)
};

//downloads
web.start_download = function (url, filename) {
	const downloadId = 'dl_' + new Date().getTime();
	const iframe = document.createElement('iframe');
	iframe.id = downloadId;
	iframe.style.display = 'none';
	document.body.appendChild(iframe);
	iframe.src = url;

	web.normal_message(web.current_language_code === 'tr' ? filename + " indiriliyor" : filename + " is being downloaded");

	setTimeout(function () {
		document.body.removeChild(iframe);
		web.success_message();
	}, 2000);
}

//ajax
web.get = function (target, call_back) {
	$.get(target, function (html) {
		call_back(1, html);
	}).fail(function (jqXHR, textStatus) {
		console.log("Request failed:" + textStatus);
		call_back(0);
	});
};

web.post = function (target, p, call_back) {
	$.post("/functions/" + target + ".php", JSON.stringify(p), function (data) {
		if (call_back) {
			call_back(1, data);
		}
	}).fail(function (jqXHR, textStatus) {
		console.log("Request failed:" + textStatus);
		if (call_back) {
			call_back(0);
		}
	});
};

web.post_form = function (target, data, call_back) {
	$.ajax({
		url: "/functions/" + target + ".php",
		dataType: "text",
		cache: false,
		contentType: false,
		processData: false,
		data: data,
		type: "post",
		success: function (data) {
			if (call_back) {
				call_back(1, data);
			}
		},
		error: function (jqXHR, textStatus) {
			console.log("Request failed:" + textStatus);
			if (call_back) {
				call_back(0);
			}
		},
	});
};
